import React from 'react';
import { Pie, Bar } from 'react-chartjs-2';

const AnalyticsCharts = ({ popularPlansData, billingData, pieOptions, barOptions }) => {
  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Analytics Dashboard</h2>
        
        {/* Quick Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-blue-50 rounded-lg p-4">
            <h3 className="text-lg font-semibold text-blue-800 mb-2">Subscription Growth</h3>
            <p className="text-blue-600">Coming soon: Monthly subscription trends</p>
          </div>
          <div className="bg-green-50 rounded-lg p-4">
            <h3 className="text-lg font-semibold text-green-800 mb-2">Revenue Analytics</h3>
            <p className="text-green-600">Coming soon: Revenue breakdown by plan</p>
          </div>
          <div className="bg-purple-50 rounded-lg p-4">
            <h3 className="text-lg font-semibold text-purple-800 mb-2">Customer Insights</h3>
            <p className="text-purple-600">Coming soon: Customer behavior analytics</p>
          </div>
        </div>
        
        {/* Current Data Summary */}
        <div className="border-t pt-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">Current Data Summary</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-50 rounded-lg p-4">
              <h4 className="font-medium text-gray-700 mb-2">Popular Plans</h4>
              {popularPlansData ? (
                <div className="h-96 w-full">
                  <Pie data={popularPlansData} options={pieOptions} />
                </div>
              ) : (
                <p className="text-gray-500 text-sm">No data available</p>
              )}
            </div>
            <div className="bg-gray-50 rounded-lg p-4">
              <h4 className="font-medium text-gray-700 mb-2">Billing Distribution</h4>
              {billingData ? (
                <div className="h-96 w-full">
                  <Bar data={billingData} options={barOptions} />
                </div>
              ) : (
                <p className="text-gray-500 text-sm">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsCharts;